import React from 'react';

export default ({ children, className }) => (
    <a href='#form' className={className}>
        { children }
    </a>
);
